import { acaoSobDemanda, telaSobDemanda } from '../../nucleo/paginas/TelaSobDemanda';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { api } from '../../nucleo/api';
import { CartaoIndicador } from '../../nucleo/ui/Estados';
import type { ModuloWeb } from '../../nucleo/modulos';
import { dicionario } from './i18n';
import { formatarDinheiro, type Metricas } from './tipos';

/** F10: oportunidades abertas e valor em negociação no Início (ROB-01: cartão do núcleo com estado de erro). */
function Indicadores() {
  const { t, i18n } = useTranslation('pipeline');
  const q = useQuery({ queryKey: ['pipeline', 'metricas', 'inicio'], queryFn: () => api<Metricas>('/api/v1/pipeline/metricas') });
  const v = q.data?.valor_negociacao[0];
  const itens = [
    { rotulo: t('indicadores.abertas'), valor: q.data ? String(q.data.abertas) : null },
    { rotulo: t('indicadores.valor'), valor: q.data ? formatarDinheiro(v?.centavos ?? '0', v?.moeda ?? 'BRL', i18n.language) : null },
  ];
  return (
    <>
      {itens.map((i) => (
        <CartaoIndicador key={i.rotulo} rotulo={i.rotulo} valor={i.valor} consultas={[q]} />
      ))}
    </>
  );
}

const carregar0 = () => import('./Pipeline');
const carregar1 = () => import('./FichaOportunidade');
const carregar2 = () => import('./PainelParceiro');
const carregar3 = () => import('./Atividades');
const carregar4 = () => import('./Configuracao');

const AcaoPipeline = acaoSobDemanda(carregar0, 'AcaoPipeline');
const Pipeline = telaSobDemanda(carregar0, 'Pipeline');
const FichaOportunidade = telaSobDemanda(carregar1, 'FichaOportunidade');
const PainelParceiro = telaSobDemanda(carregar2, 'PainelParceiro');
const AcaoAtividades = acaoSobDemanda(carregar3, 'AcaoAtividades');
const Atividades = telaSobDemanda(carregar3, 'Atividades');
const AcaoEquipes = acaoSobDemanda(carregar4, 'AcaoEquipes');
const AcaoMetas = acaoSobDemanda(carregar4, 'AcaoMetas');
const AcaoMotivos = acaoSobDemanda(carregar4, 'AcaoMotivos');
const Equipes = telaSobDemanda(carregar4, 'Equipes');
const Metas = telaSobDemanda(carregar4, 'Metas');
const Motivos = telaSobDemanda(carregar4, 'Motivos');

export const modulo: ModuloWeb = {
  slug: 'pipeline',
  menu: 'comercial',
  dicionario,
  abas: [
    { rotulo: 'abas.pipeline', caminho: 'pipeline', elemento: <Pipeline />, Acao: AcaoPipeline, ordem: 1 },
    { rotulo: 'abas.equipes', caminho: 'equipes', elemento: <Equipes />, Acao: AcaoEquipes, ordem: 2 },
    { rotulo: 'abas.metas', caminho: 'metas', elemento: <Metas />, Acao: AcaoMetas, ordem: 3 },
    { rotulo: 'abas.motivos', caminho: 'motivos-de-perda', elemento: <Motivos />, Acao: AcaoMotivos, ordem: 4 },
    { rotulo: 'abas.atividades', caminho: 'atividades', elemento: <Atividades />, Acao: AcaoAtividades, ordem: 5 },
  ],
  rotas: [{ path: 'comercial/oportunidades/:id', element: <FichaOportunidade /> }],
  Indicadores,
  // M1.7 (SPEC1-03): oportunidades do cliente na ficha do parceiro de Cadastros.
  paineis: [{ entidade: 'cadastros.parceiro', titulo: 'painel.titulo', Componente: PainelParceiro, ordem: 10 }],
};
